export default {
    info: 'Hier können gespeicherte Filterkombinationen wieder gelöscht werden.',

    name: 'Name',
    table_module: 'Tabelle',
    filter_data: 'Filterdaten',

    delete: 'Filterkombination löschen',
    deleteText: 'Möchten Sie diese Filterkombination wirklich löschen?',
    deleteSuccess: 'Die Filterkombination wurde erfolgreich gelöscht.',
    deleteError: 'Die Filterkombination konnte nicht gelöscht werden.',

    table_modules: {
        processes: 'Maßnahmen',
    }
}